import '/assets/styles/partials/empty-message.scss';
import classNames from 'classnames';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';

const EmptyMessage = ({ className, children, icon = 'info', title, html }) => (
	<div
		className={classNames('emptymessage', className)}>
		{icon && <Icon className="emptymessage-icon" name={icon} />}
		<div className="emptymessage-contentwrap">
			{title && <strong className="emptymessage-title">{title}</strong>}
			{html && (
				<div
					className="emptymessage-content"
					dangerouslySetInnerHTML={{ __html: html }} />
			)}
			{children && <div className="emptymessage-content">{children}</div>}
		</div>
	</div>
);

export default EmptyMessage;
